export default {"src":"/_next/static/media/box.dc9449e6.svg","height":21,"width":22};